const ApiPermissions = {
    READ_SERVICES: 'read-services',
    CREATE_SERVICES: 'create-services',
    UPDATE_SERVICES: 'update-services',
};

export default ApiPermissions;
